import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './conflict-service.html';
import moment from 'moment';

const COMPONENT_NAME = 'ConflictService';

const CONFLICT_RESOLUTIONS = {
  MINE: 'mine',
  SERVER: 'server',
  POSTPONE: 'postPone'
};

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, ($rootScope, $q, $uibModal, $timeout, ContentService, UserDataService, UserProfileModal, KeyboardShortcutService) => {
    function createVersionInfo (conflictInformation) {
      var versionId = conflictInformation.conflictingVersion;
      var creationTime = conflictInformation.lastModified;
      var author = conflictInformation.committer;

      return {
        version: versionId.replace('contentid/', ''),
        creationTime: moment(creationTime).format('ll, LTS'),
        author
      };
    }

    function requestConflictResolution (conflictInformation, contentObject) {
      var deferred = $q.defer();
      var modalScope = $rootScope.$new(true);

      modalScope.oldVersionInfo = createVersionInfo(conflictInformation);
      modalScope.error = undefined;
      modalScope.errorMessage = undefined;
      modalScope.showFullChanges = false;
      modalScope.loading = true;
      modalScope.committer = conflictInformation.committer;

      modalScope.chooseServerVersion = function () {
        modalScope.close();
        deferred.resolve(CONFLICT_RESOLUTIONS.SERVER);
      };

      modalScope.chooseLocalVersion = function () {
        modalScope.close();
        deferred.resolve(CONFLICT_RESOLUTIONS.MINE);
      };

      modalScope.postponeChoice = function () {
        modalScope.close();
        deferred.resolve(CONFLICT_RESOLUTIONS.POSTPONE);
      };

      var modal = $uibModal.open({
        scope: modalScope,
        template,
        windowClass: 'code-generic-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      modalScope.close = function () {
        modal.close();
        modalScope.$destroy();
      };

      modalScope.openUserInModal = function (userPassport) {
        UserProfileModal.open(modalScope, userPassport);
      };

      modalScope.$on('$destroy', function () {
        KeyboardShortcutService.pop();
      });

      KeyboardShortcutService.hideAndPush({
        'escape': {
          action: function () {
            modalScope.postponeChoice();
          },

          label: 'Cancel conflict modal'
        }
      });

      $timeout(function () {
        UserDataService.getUserData(conflictInformation.committer)
          .then(function (currentUserData) {
            modalScope.conflictingVersionUserPassport = atex.aceui.ObjectUtils.getByPath(currentUserData, 'userData/acePassport');
          });

        ContentService.getContentVersion({
          version: conflictInformation.conflictingVersion,
          fullTypeInfo: true
        })
          .then(function (result) {
            modalScope.contents = [];
            modalScope.contents[0] = result.content;
            modalScope.contents[1] = contentObject;
            modalScope.loading = false;
          })
          .then(undefined, function (error) {
            console.warn('Error while calculating content changes!', error);

            modalScope.error = error;
            modalScope.loading = false;
            modalScope.errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
              ? error.cause : 'Error while calculating content changes.';
          });
      }, 32);

      return deferred.promise;
    }

    return {
      CONFLICT_RESOLUTIONS,
      requestConflictResolution
    };
  });

export default COMPONENT_NAME;